<template>
  <div>

    <el-dialog
      title="Choose a month to pre-load"
      :visible.sync="dialog"
      width="40%"
      center>
      <p>You can choose to load now the data you are going to use throughout the session. Just pick a month</p>
      <div class="block" style="text-align: center!important;">
        <el-date-picker
          v-model="choosenMonth"
          type="month"
          placeholder="Pick a month">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loadMonth()">Confirm</el-button>
      </span>
    </el-dialog>

    <el-col :span="1">
      <router-link :to="`/index`">
        <p id="backButton"><i class="el-icon-arrow-left"></i></p>
      </router-link>
    </el-col>
    <el-col :span="22" :offset="1">
      <el-tabs>
        <el-tab-pane ><span slot="label"><i class="el-icon-document"></i> Device properties</span><app-deviceproperties :deviceId="$route.params.deviceId"></app-deviceproperties></el-tab-pane>
        <el-tab-pane ><span slot="label"><i class="el-icon-search"></i> Advanced query</span><app-query :deviceId="$route.params.deviceId" :listParams="listParams"></app-query></el-tab-pane>
        <el-tab-pane ><span slot="label"><i class="el-icon-menu"></i> Realtime graph</span><app-realtime :deviceId="$route.params.deviceId" :listParams="listParams"></app-realtime></el-tab-pane>
      </el-tabs>
    </el-col>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        dialog: false,
        choosenMonth: '',
        startDate: '',
        finishDate: '',
        deviceId: ' ',
        listParams: '',
      };
    },
    methods:{
      loadMonth: function () {
        var app = this;
        this.dialog = false;

        this.startDate = `${this.choosenMonth.getFullYear()}_${("0" + (this.choosenMonth.getMonth()+1)).slice(-2)}_${("0"+this.choosenMonth.getDate()).slice(-2)}_0_0_0`
        this.finishDate = `${this.choosenMonth.getFullYear()}_${("0"+(this.choosenMonth.getMonth()+1)).slice(-2)}_${("0"+new Date(this.choosenMonth.getFullYear(), this.choosenMonth.getUTCMonth()+1, 0).getDate()).slice(-2)}_0_0_0`

        this.$notify({
          title: 'Working...',
          message: '...working on your requested period...',
          showClose: false,
          type: "warning",
        });

        axios.post(`https://iiot.dave.eu/api/customQuery`, {
          device: app.$route.params.deviceId,
          startPoint: app.startDate,
          finishPoint: app.finishDate,
          query: "NoQueryJustDataLoad"
        }).then(function (response) {
            app.$notify({
              title: 'Ok!',
              message: `Loaded data successfully`,
              type: 'success'
            });
          }).catch(function (error){
            app.$notify.error({
              title: 'ERROR',
              message: "ERROR during database querying",
            });
        })
      }
    },
    mounted: function () {
      var app = this;
      setTimeout(function () {
        // If the screen is too small it doesn't even show the dialog
        if(screen.width >= 768)
          app.dialog = true;
      }, 600)
    },
    /* These instructions get executed when the component is loaded */
    created: function () {
      let app = this;

      /* Ajax call to get all parameters from database */
      axios.get(`https://iiot.dave.eu/api/params`)
        .then(function (response) {
          app.listParams = response.data
        }).catch(function (error){
        console.error(`Download Parameters ERROR: ${error.response.data.message}`);
      });
    }
  };
</script>

<style scoped>

  /* Tablets and smaller */
  @media only screen and (max-width: 768px) {
    #backButton{
      display: none!important;
    }
  }
  #backButton{
    background-color: var(--tertiary-color);
    border: 1px solid var(--secondary-color);
    border-radius: 10px;
    display:inline-block;
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    transition: .15s all ease-out;
  }
  #backButton:hover{
    cursor: pointer;
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/Device.vue